import _ from 'lodash'
import { ErrorBoundary } from 'react-error-boundary'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'
import PageError from '../../Common/PageError'
import { API_ERROR_MAPPING } from '../../../constants/globalTypes'

const FallbackComponent = props => {
  const { error = {}, children } = props
  const errorCode = error.code
  const errorMessage = (
    error.message ||
    _.get(API_ERROR_MAPPING, errorCode, errorCode)
  )
  if (!children) {
    return (
      <PageError errorMessage={errorMessage} />
    )
  }

  return (
    <PageError
      errorMessage={errorMessage}
      withErrorMessage
      withImage
    >
      {children}
    </PageError>
  )
}

export const withErrorBoundary = WrappedComponent => props => {
  const initBoundaryError = _.get(props, 'page.errorBoundaryError')
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <FallbackComponent error={error}>
          {props.errorPageSubContent}
        </FallbackComponent>
      )}
    >
      {
        _.isEmpty(initBoundaryError)
          ? <WrappedComponent {...props} />
          : (
            <FallbackComponent error={initBoundaryError}>
              {props.errorPageSubContent}
            </FallbackComponent>
          )
      }
    </ErrorBoundary>
  )
}

export const withCommonPageErrorBoundary = errorPageSubContent => WrappedComponent => props => {
  const propsWithErrorContent = {
    ...props,
    errorPageSubContent
  }
  return (
    <CommonPage>
      {withErrorBoundary(WrappedComponent)(propsWithErrorContent)}
    </CommonPage>
  )
}
